import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { InputField } from "../../../../Components/formElements/InputField";
import * as XLSX from "xlsx";

const UploadXlSheetModal = React.forwardRef((props, ref) => {
  const { onFormDataChange } = props;

  const { data } = props;

  const [formData, setFormData] = useState({});

  //  useEffect(() => {

  // }, [formData, onFormDataChange]);

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line no-unused-vars
  const [getErrorFields, setErrorFields] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [disable, setDisabled] = useState(false);

  useEffect(() => {
    if (props.show) {
      setFormData({});
    }
  }, [props.show, data]);

  const handleSubmit = async () => {
    if (onFormDataChange) {
      onFormDataChange(formData);
    }
    // console.log(">>formData", formData);

    props?.onHide();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Get first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      //   const nestedData = jsonData.map(row => ({
      //   // companyCode: row.companyCode,
      //   // customerCode: row.customerCode,
      //   items: JSON.parse(row?.items),
      //   certifications: JSON.parse(row?.certifications),
      //   // ... add other keys
      // }));

      // // send nestedData to backend
      // console.log(">>nestedData",nestedData);

      if (jsonData.length > 0) {
        setFormData(jsonData);
      }

      //  console.log("Parsed Excel Data: ", jsonData);
    };

    reader.readAsArrayBuffer(file);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    // Reset form when modal is closed
    if (!props.show) {
      setFormData({
        uploadXlFilel: "",
      });
    }
  }, [props.show, setFormData]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Upload Xl Sheet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Upload File"
              name="uploadXlFile"
              id="uploadXlFilel"
              accept=".xlsx, .xls"
              type="file"
              extraLabel=""
              placeholder="Upload Xl file "
              // value={formData.uploadXlFile || ""}
              onChange={handleFileUpload}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleSubmit}
          disabled={disable}
          className="btn btn-primary"
        >
          Upload
        </button>
        <button onClick={props?.onHide} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </Modal>
  );
});

export default UploadXlSheetModal;
